import {
	Container,
	TokenTextAppearance,
	TextAlignment,
	TokenTextColor,
	BreakpointWrapper,
	Breakpoints,
	styled,
	Text,
} from '@volkswagen-onehub/components-core';
import React from 'react';

const HelpContainerStyled = styled.div`
	background-color: #f3f4f5;
	border-radius: 16px;
	padding: var(--size-dynamic0050);
`;

export const HelpContainer = (): React.ReactElement => {
	return (
		<HelpContainerStyled>
			<Container wrap={'always'} horizontalAlign={'center'}>
				<Text
					appearance={TokenTextAppearance.label200}
					textAlign={TextAlignment.center}
					color={TokenTextColor.primary}
					bold
				>
					¿Necesitas ayuda?
				</Text>
				<BreakpointWrapper min={Breakpoints.default} max={Breakpoints.b960}>
					<Text
						appearance={TokenTextAppearance.copy100}
						textAlign={TextAlignment.center}
						color={TokenTextColor.primary}
					>
						Llámanos al 800 500 100
					</Text>
					<Text
						appearance={TokenTextAppearance.copy100}
						textAlign={TextAlignment.center}
						color={TokenTextColor.primary}
					>
						o mándanos un WhatsApp al 638 68 01 00.
					</Text>
				</BreakpointWrapper>
				<BreakpointWrapper min={Breakpoints.b960}>
					<Text
						appearance={TokenTextAppearance.copy100}
						textAlign={TextAlignment.center}
						color={TokenTextColor.primary}
					>
						Llámanos al 800 500 100 o mándanos un WhatsApp al 638 68 01 00.
					</Text>
				</BreakpointWrapper>
			</Container>
		</HelpContainerStyled>
	);
};
